// extracted by mini-css-extract-plugin
export default {"link":"x1IhEjCURMMDj6KqF0D7"};